import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDanhSachKiemKho,
  updateDataSearch,
} from "../../actions/DanhSachKiemKho";

export const TableDanhSachKiemKho = ({ quyenXemChiTiet, quyenInChiTiet }) => {
  //Code
  const dispatch = useDispatch();
  const listDsKiemKhoFull = useSelector(
    (state) => state.listDanhSachKiemKhoFull
  ); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchDanhSachKiemKho); //dataSearchTaiSan dinh nghia o rootreducer
  // {
  //   console.log(listDsKiemKhoFull);
  // }
  useEffect(() => {
    dispatch(getListDanhSachKiemKho(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListDanhSachKiemKho(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListDanhSachKiemKho(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listDsKiemKhoFull.TotalQuantity;
  console.log(listDsKiemKhoFull);
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile   table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers"  style={{ position: "sticky", padding: "2px", top: "0rem", zIndex: "999", background:"#FFFFFF", padding:"1px 0"}}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listDsKiemKhoFull.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  text-center">Thời gian</p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="text-center">Mã</p>
                  </div>

                  <div className="custom-table-header flex-basis-40 flex-basis-40-sm">
                    <p className="text-left">Người kiểm</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header text-left">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listDsKiemKhoFull={listDsKiemKhoFull.List}
                    quyenXemChiTiet={quyenXemChiTiet}
                    quyenInChiTiet={quyenInChiTiet}
                  />
                </div>
              </div>
            </div>
            {/* <div
        className={
          "paniation-new paniation-new1 d-flex justify-content-center " +
          (TotalQuantity === 0 ? "hidden" : "")
        }
      >
        <nav aria-label="Page navigation">
          <Pagination
            activePage={data.pageIndex}
            itemsCountPerPage={data.pageSize}
            totalItemsCount={TotalQuantity}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
          />
        </nav>
      </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
